export default __webpack_public_path__ + "458c5f1bb54687634f64aee6484ce803.png";